import {StoreSplitAccountReportDto} from "@/api/appService";

export interface StoreSplitAccountMonthValues {
  month: number;
  value: StoreSplitAccountReportDto
}

export interface MonthTotal {

  month: number

  income: number;
  splitAmountToHeadquarters: number,
  splitAmountToStore: number,
  splitAmountToPartialArea: number,
}

export type MonthTotalValues = {[key: number]: MonthTotal};

export interface StoreMonthValues {
  storeId: number
  storeName: string;

  remark: string;

  monthValues: StoreSplitAccountMonthValues[];

  total:{
    income: number,
    splitAmountToHeadquarters: number,
    splitAmountToStore: number,
    splitAmountToPartialArea: number,
  }
}

export interface PartialAreaData {
  partialAreaId: number;
  partialAreaName: string;
  rowSpan: number;
  stores: StoreMonthValues[];
}

export interface BigAreaData {
  bigAreaId: number;
  bigAreaName: string;
  rowSpan: number;
  partialAreas: PartialAreaData[];
}

export function convert2DisplayRows(values: StoreSplitAccountReportDto[]): BigAreaData[] {

  const bigAreas: BigAreaData[] = [];
  for (const element of values) {
    const row = element;
    let bigArea = bigAreas.find(x => x.bigAreaId == row.bigAreaId);
    if (!bigArea) {
      bigArea = {
        bigAreaId: row.bigAreaId!,
        bigAreaName: row.bigAreaName!,
        partialAreas: [],
        rowSpan:1,
      };
      bigAreas.push(bigArea);
    }

    let partialArea = bigArea.partialAreas.find(x => x.partialAreaId == row.partialAreaId);
    if (!partialArea) {
      partialArea = {
        partialAreaId: row.partialAreaId!,
        partialAreaName: row.partialAreaName!,
        stores: [],
        rowSpan:1
      };
      bigArea.partialAreas.push(partialArea);
    }

    let store = partialArea.stores.find(x => x.storeId == row.storeId);
    if (!store) {
      store = {
        storeId: row.storeId!,
        storeName: row.storeName!,
        monthValues: [],
        remark: row.remark!,
        total:{
          income: 0,
          splitAmountToHeadquarters: 0,
          splitAmountToStore: 0,
          splitAmountToPartialArea: 0,
        }
      };
      partialArea.stores.push(store);
    }

    store.monthValues.push({
      month: row.month!,
      value: row
    })

  }

  fillMonthValues(bigAreas);

  return bigAreas;


}


export function calcMonthTotals(allData: BigAreaData[]): MonthTotalValues {

  const defaultValue:MonthTotal = {
    income:0,
    splitAmountToHeadquarters:0,
    splitAmountToPartialArea:0,
    splitAmountToStore:0,
    month:0
  }

  const result:MonthTotalValues = {};
  for(let i = 1;i<=12;i++){
    result[i] = {...defaultValue,month:i}
  }

  for(let bigArea of allData){
    for(let partialArea of bigArea.partialAreas){
      for(let store of partialArea.stores){
        for(let item of store.monthValues) {
          result[item.month].income += item.value.income??0;
          result[item.month].splitAmountToStore += item.value.splitAmountToStore??0;
          result[item.month].splitAmountToHeadquarters += item.value.splitAmountToHeadquarters??0;
          result[item.month].splitAmountToPartialArea += item.value.splitAmountToPartialArea??0;
        }
      }
    }
  }

  return result;
}

function fillMonthValues(bigAreas: BigAreaData[]) {
  let bigAreaRowSpan = 0;
  let partialAreaRowSpan = 0;
  for (let bigArea of bigAreas) {
    bigAreaRowSpan = 0;
    for (let partialArea of bigArea.partialAreas) {
      partialAreaRowSpan = 0;
      for (let store of partialArea.stores) {
        bigAreaRowSpan++;
        partialAreaRowSpan++;
        for (let month = 1; month <= 12; month++) {
          if (store.monthValues.some(x => x.month == month)) continue;

          store.monthValues.push({
            month: month,
            value: {
              id: undefined,
              income: 0,
              splitAmountToHeadquarters: 0,
              splitAmountToStore: 0,
              splitAmountToPartialArea: 0,
              storeSplitPercent: 0,
              partialAreaSplitPercent: 0,
              fee1: 0,
              fee2: 0,
              fee3: 0,
              month: month
            }
          })

        }
        store.monthValues = store.monthValues.sort((a, b) => a.month - b.month);

        for(let monthValue of store.monthValues){
          store.total.income += monthValue.value.income??0;
          store.total.splitAmountToHeadquarters += monthValue.value.splitAmountToHeadquarters??0;
          store.total.splitAmountToStore += monthValue.value.splitAmountToStore??0;
          store.total.splitAmountToPartialArea += monthValue.value.splitAmountToPartialArea??0;
        }
      }

      partialArea.rowSpan = partialAreaRowSpan;

    }
    bigArea.rowSpan = bigAreaRowSpan;
  }
}
